import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '@/components/SectionTitle';
import Seo from '@/seo/Seo';
import { PAGE_SEO } from '@/seo/seoConfig';
import { breadcrumbSchema } from '@/seo/schemas';
import { BookOpen, Heart, Shield, Phone } from 'lucide-react';

export default function SundaySchool() {
  return (
    <div>
      <Seo
        title={PAGE_SEO.sundaySchool.title}
        titleExact
        description={PAGE_SEO.sundaySchool.description}
        keywords={PAGE_SEO.sundaySchool.keywords}
        path="/services/sunday-school"
        jsonLd={[breadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'Services', path: '/services' },
          { name: 'Sunday School', path: '/services/sunday-school' },
        ])]}
      />
      <section className="gradient-purple text-white py-12 sm:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <Link to="/services" className="text-moj-gold text-sm hover:underline">← Back to all services</Link>
          <h1 className="font-serif text-4xl sm:text-5xl text-white mt-3 mb-3">Sunday School</h1>
          <p className="text-lg text-white/90 max-w-3xl">Sunday School at Ministry of Jesus helps children grow in the knowledge of God through Bible stories, worship, prayer, crafts, memory verses, and caring guidance.</p>
        </div>
      </section>

      <section className="py-16 bg-moj-cream">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 grid md:grid-cols-2 gap-10">
          <img src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=900&h=600&fit=crop" alt="Children studying the Bible" className="rounded-2xl shadow-xl"/>
          <div>
            <SectionTitle kicker="Children's Ministry" title="Bringing children to Jesus"
              subtitle="Every Sunday we welcome children into an age-appropriate environment full of joy, truth and love."/>
            <div className="space-y-4">
              <div className="card-moj p-5">
                <h3 className="font-serif text-lg flex items-center gap-2"><BookOpen size={18} className="text-moj-gold-deep"/> Age Groups</h3>
                <p className="text-moj-charcoal/80 mt-1">Tots (3–5) • Juniors (6–9) • Tweens (10–13). Each group is led by trained volunteers.</p>
              </div>
              <div className="card-moj p-5">
                <h3 className="font-serif text-lg flex items-center gap-2"><Heart size={18} className="text-moj-gold-deep"/> Our Teaching Approach</h3>
                <p className="text-moj-charcoal/80 mt-1">Bible stories, memory verses, songs of worship, prayer time, crafts and small-group conversations — all designed to plant the Word in young hearts.</p>
              </div>
              <div className="card-moj p-5 border-l-4 border-moj-gold">
                <h3 className="font-serif text-lg flex items-center gap-2"><Shield size={18} className="text-moj-gold-deep"/> Safeguarding</h3>
                <p className="text-moj-charcoal/80 mt-1">All Sunday School volunteers are Garda-vetted and follow our safeguarding policy. Your child’s safety is sacred to us.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 gradient-purple text-white text-center">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <h2 className="font-serif text-3xl text-white mb-3">Parents — we’d love to meet you</h2>
          <p className="text-white/90 mb-6">Reach out to our Sunday School lead and we’ll be happy to welcome your child for a visit.</p>
          <Link to="/contact" className="btn-gold"><Phone size={16}/> Contact Sunday School</Link>
        </div>
      </section>
    </div>
  );
}
